<template>
	<!-- 弹出框 -->
	<a-modal v-model="modal.visible" :title="modal.title" @cancel="cancel" :width="720" :footer="null">
		<a-form-model ref="ruleForm" layout="inline" :model="queryParam" :rules="rules">
			<a-form-model-item label="手机号"><a-input v-model="queryParam.mobile" :maxLength="20" /></a-form-model-item>
			<a-form-model-item label="用户昵称"><a-input v-model="queryParam.nickName" :maxLength="20" /></a-form-model-item>
			<a-form-model-item><a-button type="primary" @click="search">查询</a-button></a-form-model-item>
		</a-form-model>
		
		<!-- 数据表格 -->
		<s-table ref="table" size="default" rowKey="id" :columns="columns" :isAuto="false" :data="loadData" showPagination="auto">
			<span slot="action" slot-scope="text, record">
				<template>
					<a-button type="primary" size="small"  @click="add(record)" :disabled="confirmLoading">添加</a-button>
				</template>
			</span>
		</s-table>
	</a-modal>
</template>

<script>
import { STable } from '@/components';
export default {
	name: 'AddKeeper',
	components: {
		STable
	},
	data() {
		return {
			merchantNo: "",
			confirmLoading: false,
			//弹出框参数
			modal: {
				visible: false,
				title: '添加管家',
				type: 'add'
			},
			//form
			queryParam: {
				mobile: '',
				nickName: ''
			},
			//form rules
			rules: {
				// mobile: [
				// 	{ validator: handle }
				// ],
				// nickName: [
				// 	{ validator: handle }
				// ]
			},
			// 表头
			columns: [
				{
					title: '用户编号',
					dataIndex: 'userNo'
				},
				{
					title: '用户昵称',
					dataIndex: 'nickName'
				},
				{
					title: '手机号',
					dataIndex: 'mobile'
				},
				{
					title: '性别',
					dataIndex: 'sex'
				},
				{
					title: '操作',
					dataIndex: 'action',
					align: 'left',
					scopedSlots: { customRender: 'action' }
				}
			],
			//加载数据方法 必须为 Promise 对象
			loadData: parameter => {
				return this.$http.roomBksApi.pageKeeprUserBase(Object.assign(parameter, this.queryParam)).then(res => {
					return res.resultObject;
				});
			}
		};
	},
	created() {},
	methods: {
		showModal(merchantNo) {
			this.merchantNo = merchantNo; 
			this.modal.visible = true;
		},
		cancel() {
			this.merchantNo = "";
			this.confirmLoading = false;
			this.$refs.ruleForm.resetFields();
			this.modal.visible = false;
		},
		/**
		 * 查询
		 */
		search() {
			if (!this.queryParam.mobile && !this.queryParam.nickName) {
				this.$message.error("手机号和用户昵称不能同时为空");
				return;
			}
			this.$refs.table.refresh(true);
		},
		add(item){
			this.confirmLoading = true;
			let param = {};
			param.userNo = item.userNo;
			param.merchantNo = this.merchantNo;
			this.$http.roomBksApi.saveHouseMerchantKeeper(param).then(res =>{
				this.confirmLoading = false;
				if(res.result == 0){
					this.cancel();
					this.$message.success(res.msg);
					this.$emit("success");
				}
			});
		}
	}
};
</script>

<style></style>
